import React from 'react'
import { SvgIconProps } from './Home'

const SvgBadgesIcon = ({ fill, width, height }: SvgIconProps) => (
  <svg width={width ?? '24'} height={width ?? '24'} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.5 3.44336C11.8094 3.26473 12.1906 3.26473 12.5 3.44336L19.1602 7.28906C19.4694 7.46764 19.66 7.79722 19.6602 8.1543V15.8457C19.66 16.2028 19.4694 16.5324 19.1602 16.7109L12.5 20.5566C12.1906 20.7353 11.8094 20.7353 11.5 20.5566L4.83984 16.7109C4.53061 16.5324 4.33999 16.2028 4.33984 15.8457V8.1543C4.33999 7.79722 4.53061 7.46764 4.83984 7.28906L11.5 3.44336Z"
      stroke={fill ?? '#95358F'}
      stroke-width="2"
    />
    <path
      d="M9.96566 12.9429L9.8809 14.1429C9.8809 14.4 9.96566 14.6571 10.22 14.8286C10.3895 14.9143 10.4742 15 10.6438 15C10.7285 15 10.8981 15 10.9828 14.9143L12 14.4L13.0172 14.9143C13.1019 15 13.1867 15 13.3562 15C13.5258 15 13.6953 14.9143 13.78 14.8286C14.0343 14.6571 14.1191 14.4 14.1191 14.1429L14.0343 12.9429L14.7972 12C14.9667 11.8286 15.0515 11.4857 14.9667 11.2286C14.882 10.9714 14.7125 10.8 14.3734 10.7143L13.2715 10.4571L12.6781 9.42857C12.5933 9.34286 12.5086 9.17143 12.4238 9.17143C12.2543 9 12.1695 9 12 9C11.7457 9 11.4914 9.17143 11.3219 9.42857L10.7285 10.4571L9.6266 10.7143C9.37231 10.8 9.11802 10.9714 9.03325 11.2286C8.94849 11.4857 9.03325 11.7429 9.20278 12L9.96566 12.9429Z"
      fill={fill ?? '#95358F'}
    />
  </svg>
)

export default SvgBadgesIcon
